export default () => ({
  id          : null,
  uuid        : null,
  languageId  : null,
  hostname    : null,
  institution : {
    id         : null,
    uuid       : null,
    languageId : null,
    hostname   : null
  },
  /** @deprecated */
  alias    : null,
  /** @deprecated */
  iesAlias : null
});
